module.exports = __webpack_public_path__ + "static/novacair-cover-cd91ee5738cdfca0b44a7c4af45719ec.png";